const AppLayout = (resolve) =>
  require(['@/components/layout/AppLayout'], resolve);
const _import = (path, subPath) =>
  require('@/components/page/meetingplan/' +
    path +
    (subPath ? `/${subPath}/index` : '/index'));

const routes = {
  path: '/meetingplan',
  component: AppLayout,
  meta: {
    title: 'meetingplan.task.title',
    hidden: false,
    name: 'meetingplan-task'
  },
  redirect: 'task',
  children: [
    {
      path: 'task',
      name: 'meetingplan-task',
      meta: {
        title: 'meetingplan.task',        
        hidden: true,
      },
      component: _import('task')
    },
    {
      path: 'task/view/:id',
      name: 'meetingplan-task-view',
      meta: {
        title: 'meetingplan.task.view',
        hidden: false,
      },
      component: _import('task','view')
    }
  ]
};

export default routes;



// WEBPACK FOOTER //
// ./src/router/meetingplantask.js